import Typeahead from "./typeahead";
import typeaheadAutocompleteTemplates from "../templates/typeahead";
import Helpers from "./helpers";

declare var Mustache: any;

export default class SearchAutocompleteDesktop {

	private dimmer: HTMLElement;
	private dimmerShowCSSClass = 'js-mega-nav-dimmer--show';
	private dimmerFadeCSSClass = 'js-mega-nav-dimmer--fade';
	private fadeOutTimer: ReturnType<typeof setTimeout>;

	constructor() {
		this.setupAutocomplete();
	}

	private getDimmer(): HTMLElement {
		if (!this.dimmer) {
			this.dimmer = document.querySelector('.js-mega-nav-dimmer--search');
		}
		return this.dimmer;
	}

	setupAutocomplete() {
		const siteSearchTypeahead = document.querySelector('[data-typeahead="siteSearch"]') as HTMLInputElement;

		if (!siteSearchTypeahead) {
			return;
		}

		const activeSite = Helpers.activeSite();

		new Typeahead(siteSearchTypeahead as HTMLInputElement, {
				charLimit: 3,
				renderInHeader: Helpers.activeSite() === "Toasty",
				onSearchResultsShow: () => {
					this.showDimmer();
				},
				onSearchResultsHide: () => {
					this.hideDimmer();
				},
				requests: [
					{
						name: 'categories',
						limit: 20,
						source: 'data-typeahead-category',
						templates: {
							header: function (data) {
								const template = typeaheadAutocompleteTemplates.header;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Categories'
								});
							},
							notFound: function () {
								const template = typeaheadAutocompleteTemplates.empty;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Categories',
									Summary: 'No categories found...'
								});
							},
							error: function () {
								const template = typeaheadAutocompleteTemplates.empty;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Error',
									Summary: 'An error has occurred. Please try again.'
								});
							},
							pending: function () {
								const template = typeaheadAutocompleteTemplates.pending;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Categories'
								});
							},
							suggestion: function (data) {
								const template = typeaheadAutocompleteTemplates.category;
								Mustache.parse(template);
								return Mustache.render(template, data);
							}
						}
					},
					{
						name: 'content',
						limit: 20,
						source: 'data-typeahead-content',
						templates: {
							header: function (data) {
								const template = typeaheadAutocompleteTemplates.header;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Content'
								});
							},
							notFound: function () {
								const template = typeaheadAutocompleteTemplates.empty;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Content',
									Summary: 'No content found...'
								});
							},
							pending: function () {
								const template = typeaheadAutocompleteTemplates.pending;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Content'
								});
							},
							error: function () {
								const template = typeaheadAutocompleteTemplates.empty;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Error',
									Summary: 'An error has occurred. Please try again.'
								});
							},
							suggestion: function (data) {
								const template = typeaheadAutocompleteTemplates.content;
								Mustache.parse(template);
								return Mustache.render(template, data);
							}
						}
					},
					{
						name: 'products',
						limit: 20,
						source: 'data-typeahead-product',
						resultsKey: 'Items',
						templates: {
							header: function (data) {
								const template = typeaheadAutocompleteTemplates.productsHeader;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Products',
									Query: data.Query,
									Count: data.Count,
									Url: '/search?term=' + data.Query
								});
							},
							footer: function (data) {
								const template = typeaheadAutocompleteTemplates.productsFooter;
								Mustache.parse(template);
								return Mustache.render(template, {
									Query: data.Query,
									Count: data.Count,
									Url: '/search?term=' + encodeURIComponent(data.Query)
								});
							},
							notFound: function () {
								const template = typeaheadAutocompleteTemplates.empty;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Products',
									Summary: 'No products found...'
								});
							},
							pending: function () {
								const template = typeaheadAutocompleteTemplates.pending;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Products'
								});
							},
							error: function () {
								const template = typeaheadAutocompleteTemplates.empty;
								Mustache.parse(template);
								return Mustache.render(template, {
									Title: 'Error',
									Summary: 'An error has occurred. Please try again.'
								});
							},
							suggestion: function (data) {
								const template = typeaheadAutocompleteTemplates.product;
								Mustache.parse(template);
								return Mustache.render(template, data);
							}
						}
					}

				]
		});

		this.hideNavOnFocus(siteSearchTypeahead);

	}

	private hideNavOnFocus(siteSearchTypeahead: HTMLInputElement) {
		siteSearchTypeahead.addEventListener('focus', () => {
			const triggerNavResetEvent = Helpers.createCustomEventForDispatch('resetNav');
			document.dispatchEvent(triggerNavResetEvent);
		});
	}

	private showDimmer() {
		const dimmer = this.getDimmer();
		if (!dimmer) {
			return;
		}
		if (this.fadeOutTimer) {
			clearTimeout(this.fadeOutTimer);
		}
		if (dimmer.classList.contains(this.dimmerFadeCSSClass)) {
			return;
		}
		dimmer.classList.add(this.dimmerShowCSSClass);
		setTimeout(() => {
			dimmer.classList.add(this.dimmerFadeCSSClass);
		}, 1);

		document.documentElement.classList.add('has-search-open');
	}

	private hideDimmer() {
		const dimmer = this.getDimmer();
		if (!dimmer) {
			return;
		}
		if (this.fadeOutTimer) {
			clearTimeout(this.fadeOutTimer);
		}
		if (!dimmer.classList.contains(this.dimmerShowCSSClass)) {
			return;
		}
		dimmer.classList.remove(this.dimmerFadeCSSClass);
		this.fadeOutTimer = setTimeout(() => {
			dimmer.classList.remove(this.dimmerShowCSSClass);
		}, 150);

		document.documentElement.classList.remove('has-search-open');
	}

}


